import api from '@pray/shared/utils/api';

export async function getAllEmailTemplates({
  artistId = '',
  type = '',
  offset = 0,
  limit = 0,
  sortColumn = '',
  sortDirection = 'asc',
} = {}) {
  const params = {
    type,
  };

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/artists/${artistId}/email-templates`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
